import { Route } from 'react-router-dom'
import { ID } from '../utils'
import ResidentCommunicationRecordsScreen from 'screens/Residents/screens/ResidentCommunicationRecordsScreen/ResidentCommunicationRecordsScreen'
import { ResidentProceduresScreen } from 'screens/Residents/screens/ResidentProceduresScreen/ResidentProceduresScreen'

export const healthRecordsRoutes = (
  communicationRecordsEnabled: boolean,
  proceduresEnabled: boolean = false
) => {
  const routes = []

  if (communicationRecordsEnabled) {
    routes.push(
      <Route
        key="communication-records"
        path={`${ID}/communication-records`}
        element={<ResidentCommunicationRecordsScreen />}
      />
    )
  }

  if (proceduresEnabled) {
    routes.push(
      <Route
        key="procedures"
        path={`${ID}/procedures`}
        element={<ResidentProceduresScreen />}
      />
    )
  }

  if (routes.length === 0) {
    return null
  }

  return <>{routes}</>
}
